import { TbHome } from 'react-icons/tb';
import { FiSearch } from 'react-icons/fi';
import { MdCalendarToday } from 'react-icons/md';
import { CgList } from 'react-icons/cg';
import { Link } from 'react-router-dom';

export default function BottomNav() {
  return (
    <div className="w-full fixed bottom-0 left-0 bg-white flex items-center justify-between py-4 px-7 border-2 border-neutralBlue2 z-50">
      <Link to={'/dashboard'}>
        <TbHome className="text-xl" />
      </Link>
      <Link to={'/find-tutor'}>
        <FiSearch className="text-xl" />
      </Link>
      <Link to={'/my-calender'}>
        <MdCalendarToday className="text-xl" />
      </Link>
      <Link to={'/my-plans'}>
        <CgList className="text-xl" />
      </Link>
    </div>
  );
}
